import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import { fetchQuestionSearch } from "../../processes/questionProccess";
import { getQuestionsByFetchedIds } from "../../selectors/questionSelectors";
import { getCurrentUser } from "../../selectors/userSelectors";
import { hasMockCourses } from "../../selectors/courseSelectors";

export default function withQuestionSearchData(WrappedComponent) {
  function WrappedComponentContainer(props) {
    const { dispatch, history, search } = props;

    const handleClose = useCallback(() => {
      history?.goBack();
    }, [history?.goBack]);

    // Trocar de página busca direto, sem passar pelo onChange do redux-form —
    // senão o debounce de 500ms da digitação seria disparado de novo.
    const handlePageChange = useCallback(
      (_event, { activePage }) => {
        fetchQuestionSearch(dispatch, search, activePage);
      },
      [dispatch, search]
    );

    useEffect(() => {
      dispatch({ type: "QUESTIONS_SEARCH_RESET" });
    }, [dispatch]);

    return (
      <WrappedComponent
        handleClose={handleClose}
        onPageChange={handlePageChange}
        {...props}
      />
    );
  }

  function mapStateToProps(state) {
    const questionSearchFormSelector = formValueSelector("questionSearchForm");
    const search = questionSearchFormSelector(state, "search");

    return {
      currentUser: getCurrentUser(state),
      isSearching: !!search,
      loading: state.questionList.loading,
      questions: getQuestionsByFetchedIds(state),
      courseLoading: state.coursesList.loading,
      hasMockCourses: hasMockCourses(state),
      search,
      totalCount: state.questionList.totalCount,
      totalPages: state.questionList.totalPages,
      currentPage: state.questionList.currentPage,
    };
  }

  return connect(mapStateToProps)(WrappedComponentContainer);
}
